import { Immutable } from "@/old-domain/types/Immutable";
import { utoa } from "../UnicodeBase64";
import { ApiRequest } from "./types";

export const getParams = (
  request: ApiRequest | Immutable<ApiRequest>
): Record<string, unknown> => {
  const params: Record<string, unknown> = {};

  if (request.query) {
    Object.assign(params, request.query);
  }
  if (request.filter) {
    Object.assign(params, request.filter);
  }
  if (request.embed) {
    // Embeds are safe to sort.
    const embeds = request.embed.map((embed) => embed.toString());
    embeds.sort();
    params.embed = embeds.join(",");
  }
  if (request.fields) {
    // Fields are safe to sort.
    const fields = request.fields.map((field) => field.toString());
    fields.sort();
    params.fields = fields.join(",");
  }
  if (request.limit) {
    params.limit = request.limit;
  }
  if (request.offset) {
    params.offset = request.offset;
  }
  if (request.search && request.search.phrases.length > 0) {
    params.search = utoa(JSON.stringify(request.search));
  }
  if (request.sort) {
    let sort = "";

    for (const [key, value] of request.sort) {
      sort += "," + (value ? "" : "-") + key;
    }

    params.sort = sort.substring(1);
  }

  return params;
};
